import React from 'react'
import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { cn } from '@/utils/cn'
import { useRouter } from '@/utils/navigation'
import { Button, ModalBody, ModalFooter, ModalHeader, ModalTitle, useModal } from '@/components/base'
import { ArrowBack, Close } from '@/components/icon'
import ScreenHeader from '@/components/ScreenHeader'

export default function KycHeader({ handlePrevStep }: { handlePrevStep?: () => void }) {
  const { t } = useTranslation()
  const { top } = useSafeAreaInsets()
  const { openModal, closeModal } = useModal()

  return (
    <View className={'bg-background-primary'} style={{ paddingTop: top }}>
      <ScreenHeader
        leftElement={
          handlePrevStep && (
            <Pressable className={'flex-row p-2'} onPress={handlePrevStep}>
              {({ pressed }) => (
                <>
                  <ArrowBack className={cn('size-6 text-text-tertiary', pressed && 'opacity-50')} />
                  <Text className={cn('text-base font-medium text-text-tertiary', pressed && 'opacity-50')}>
                    {t('kyc:previous')}
                  </Text>
                </>
              )}
            </Pressable>
          )
        }
        centerElement={<Text className={'text-base font-bold text-[#111A22]'}>{t('kyc:identityVerification')}</Text>}
        rightElement={
          <Pressable
            className={'p-2'}
            onPress={() => {
              openModal({ children: <LeaveConfirmModal onClose={closeModal} />, onClose: closeModal })
            }}
          >
            {({ pressed }) => <Close className={cn('size-6 text-text-tertiary', pressed && 'opacity-50')} />}
          </Pressable>
        }
      />
    </View>
  )
}

function LeaveConfirmModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation()
  const router = useRouter()
  return (
    <>
      <ModalHeader className={'p-4'}>
        <ModalTitle>{t('kyc:confirmLeave')}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Text className={'text-sm text-text-secondary'}>{t('kyc:leaveWarning')}</Text>
      </ModalBody>
      <ModalFooter>
        <Button className={'flex-1'} size={'md'} variant={'outline'} onPress={onClose}>
          {t('kyc:cancel')}
        </Button>
        <Button
          className={'flex-1'}
          size={'md'}
          onPress={() => {
            onClose()
            router.back()
          }}
        >
          {t('kyc:confirmLeave')}
        </Button>
      </ModalFooter>
    </>
  )
}
